const { MinimogThemeStyles, MinimogThemeScripts } = window;
class QuickView {
  constructor() {
    this.modal = new MinimogTheme.Modal();
    this.isOpen = false;
    // Event delegation for quick view button
    addEventDelegate({
      selector: ".m-product-quickview-button",
      handler: (e, target) => {
        e.preventDefault();
        this.target = target;
        this.toggleLoading(true);
        const productHandle = target.dataset.productHandle;
        if (productHandle) this.loadProductQuickView(productHandle);
      },
    });
    // Subscribe to cart update events
    window.MinimogEvents.subscribe(MinimogTheme.pubSubEvents.cartUpdate, () => {
      if (this.modal) this.close();
    });
  }
  // Load product quick view HTML
  loadProductQuickView(productHandle) {
    this.loadAssets([MinimogThemeStyles.product, MinimogThemeStyles.productInventory], "quick-view-assets")
      .then(() => {
        // FIX 1: Ensure the URL is properly constructed as a string
        const quickviewUrl = String(window.MinimogSettings.base_url) + 'products/' + String(productHandle);
        
        // FIX 2: Check if fetchSection expects an object or string parameter
        // If it expects a string, use this version:
        // return fetchSection("product-quickview", quickviewUrl);
        
        // If it expects an object with url property, use this version:
        return fetchSection("product-quickview", { url: quickviewUrl });
      })
      .then((html) => {
        // Check if html is valid before proceeding
        if (!html) {
          console.error("No HTML content returned from fetchSection");
          this.toggleLoading(false);
          return Promise.reject(new Error("No HTML content returned"));
        }
        
        this.modalContent = html.querySelector(".m-product-quickview");
        if (!this.modalContent) {
          console.error("Could not find .m-product-quickview element in the returned HTML");
          this.toggleLoading(false);
          return Promise.reject(new Error("Missing quickview content"));
        }
        
        const firstModel = html.querySelector("product-model");
        this.mediaGallery = this.modalContent.querySelector("media-gallery");
        
        return this.loadAssets(
          [MinimogThemeScripts.productMedia, MinimogThemeScripts.variantsPicker, MinimogThemeScripts.productInventory],
          "variants-picker"
        ).then(() => {
          const colorScheme = this.modalContent.dataset.colorScheme || "";
          this.modal.appendChild(this.modalContent);
          this.modal.setWidth("960px");
          this.modal.open();
          this.modal.setSizes(`m-gradient ${colorScheme}`);
          this.toggleLoading(false);
          this.isOpen = true;
          
          if (firstModel) {
            return this.loadAssets(
              [
                MinimogThemeScripts.productModel,
                "https://cdn.shopify.com/shopifycloud/model-viewer-ui/assets/v1.0/model-viewer-ui.css",
              ],
              "product-model-assets"
            );
          }
          
          return Promise.resolve();
        });
      })
      .then(() => {
        if (this.target && this.target.dataset && this.target.dataset.productHandle) {
          document.dispatchEvent(
            new CustomEvent("quick-view:loaded", {
              detail: { productUrl: this.target.dataset.productHandle },
            })
          );
        }
      })
      .catch((error) => {
        console.error("Error loading product quick view:", error);
        this.toggleLoading(false);
      });
  }
  // Load assets helper function
  loadAssets(assets, key) {
    return new Promise((resolve, reject) => {
      loadAssetsNew(assets, key, resolve, reject);
    });
  }
  // Close the quick view modal
  close(e) {
    this.modal.close(e);
    this.isOpen = false;
  }
  // Toggle loading spinner on the target element
  toggleLoading(isLoading) {
    if (this.target) {
      if (isLoading) {
        this.target.classList.add("m-spinner-loading");
      } else {
        this.target.classList.remove("m-spinner-loading");
      }
    }
  }
}
// Initialize the QuickView instance
MinimogTheme.ProductQuickView = new QuickView();